import './BrokerageContinuum.scss';
import Component from './BrokerageContinuum.js';
export default Component;
